import styled from '@emotion/styled'

export const ItemHeader = styled.div`
  font-family: Satoshi;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: 0%;
`
